import React, { useState, useRef } from 'react';
import { ArrowLeft, Search, Clock, Play } from 'lucide-react';
import { VideoPlayerModal } from './VideoPlayerModal';
interface GuidanceVideo {
  id: number;
  title: string;
  thumbnail: string;
  duration: string;
  category: string;
  description?: string;
}
interface GuidanceVideosGalleryProps {
  onClose: () => void;
  featuredVideo?: GuidanceVideo;
}
export function GuidanceVideosGallery({
  onClose,
  featuredVideo
}: GuidanceVideosGalleryProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [selectedVideo, setSelectedVideo] = useState<GuidanceVideo | null>(null);
  const categories = ['Tümü', 'Verimli Ders Çalışma', 'Motivasyon', 'Sınav Kaygısı', 'Zaman Yönetimi', 'Hedef Belirleme'];
  const guidanceVideos: GuidanceVideo[] = [{
    id: 1,
    title: 'Verimli Ders Çalışma Teknikleri',
    thumbnail: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=300&h=180&fit=crop',
    duration: '08:25',
    category: 'Verimli Ders Çalışma',
    description: 'Bu videoda, öğrenme sürecinizi hızlandıracak ve daha etkili hale getirecek bilimsel olarak kanıtlanmış çalışma teknikleri ele alınmaktadır. Pomodoro tekniği, aktif öğrenme stratejileri ve konsantrasyon artırma yöntemleri hakkında ipuçları bulacaksınız.'
  }, {
    id: 2,
    title: 'Motivasyon Artırma Yöntemleri',
    thumbnail: 'https://images.unsplash.com/photo-1552581234-26160f608093?w=300&h=180&fit=crop',
    duration: '12:17',
    category: 'Motivasyon',
    description: 'Motivasyonunuzu kaybettiğinizde kendinizi nasıl toparlayacağınızı ve hedeflerinize odaklanmaya devam edeceğinizi öğrenin. Bu video, içsel motivasyon kaynaklarınızı keşfetmenize ve uzun vadeli başarı için sürdürülebilir motivasyon stratejileri geliştirmenize yardımcı olacaktır.'
  }, {
    id: 3,
    title: 'Hedef Belirleme ve Planlama',
    thumbnail: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=300&h=180&fit=crop',
    duration: '10:05',
    category: 'Hedef Belirleme',
    description: 'Etkili hedef belirleme ve planlama, başarılı bir öğrenim sürecinin temelidir. Bu videoda SMART hedeflerin nasıl belirleneceği, uzun vadeli hedeflerin küçük adımlara nasıl bölüneceği ve ilerlemenizi nasıl takip edeceğiniz konularında pratik bilgiler verilmektedir.'
  }, {
    id: 4,
    title: 'Zaman Yönetimi Stratejileri',
    thumbnail: 'https://images.unsplash.com/photo-1483058712412-4245e9b90334?w=300&h=180&fit=crop',
    duration: '14:30',
    category: 'Zaman Yönetimi',
    description: 'Zamanınızı daha verimli kullanmanın yollarını öğrenin. Bu video, önceliklendirme teknikleri, zaman tuzaklarını belirleme ve günlük rutinlerinizi optimize etme konularında pratik stratejiler sunmaktadır. Daha fazla çalışmak yerine daha akıllıca çalışmanın sırlarını keşfedin.'
  }, {
    id: 5,
    title: 'Stres Yönetimi ve Rahatlama Teknikleri',
    thumbnail: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=300&h=180&fit=crop',
    duration: '09:45',
    category: 'Sınav Kaygısı',
    description: 'Sınav dönemlerinde yaşanan stresi azaltmak için etkili rahatlama teknikleri öğrenin. Nefes egzersizleri, progresif kas gevşetme ve zihinsel odaklanma tekniklerinin yanı sıra, stresle başa çıkmanın sağlıklı yolları bu videoda anlatılmaktadır.'
  }, {
    id: 6,
    title: 'Sosyal İlişkileri Geliştirme',
    thumbnail: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=300&h=180&fit=crop',
    duration: '11:20',
    category: 'Motivasyon',
    description: 'Güçlü sosyal ilişkiler kurmak akademik başarınızı destekleyebilir. Bu videoda, sınıf arkadaşlarınızla etkili iletişim kurma, grup çalışmalarından maksimum fayda sağlama ve sosyal destek ağınızı genişletme konularında ipuçları bulabilirsiniz.'
  }, {
    id: 7,
    title: 'Sınav Kaygısıyla Başa Çıkma Yolları',
    thumbnail: 'https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?w=300&h=180&fit=crop',
    duration: '16:42',
    category: 'Sınav Kaygısı',
    description: 'Sınav kaygısı performansınızı olumsuz etkileyebilir. Bu video, sınav öncesi ve sınav sırasında kaygıyı azaltmanın etkili yöntemlerini, zihinsel hazırlık tekniklerini ve sınav performansınızı artıracak stratejileri kapsamlı bir şekilde ele almaktadır.'
  }, {
    id: 8,
    title: 'Pomodoro Tekniği ile Çalışma',
    thumbnail: 'https://images.unsplash.com/photo-1513128034602-7814ccaddd4e?w=300&h=180&fit=crop',
    duration: '07:15',
    category: 'Verimli Ders Çalışma',
    description: 'Pomodoro tekniği, konsantrasyonu artırmak ve çalışma verimini yükseltmek için kullanılan popüler bir zaman yönetimi metodudur. Bu videoda, tekniğin nasıl uygulanacağı, kişisel ihtiyaçlarınıza göre nasıl özelleştirileceği ve en iyi sonuçları almak için dikkat edilmesi gereken noktalar anlatılmaktadır.'
  }, {
    id: 9,
    title: 'Akıllı Hedefler Belirleme',
    thumbnail: 'https://images.unsplash.com/photo-1553034545-32d4cd2168f1?w=300&h=180&fit=crop',
    duration: '13:50',
    category: 'Hedef Belirleme',
    description: 'SMART (Specific, Measurable, Achievable, Relevant, Time-bound) hedef belirleme metodolojisi, eğitim hedeflerinize ulaşmanıza yardımcı olabilir. Bu video, her bir kriterin detaylı açıklamasını yaparak, kendi SMART hedeflerinizi nasıl oluşturacağınızı adım adım göstermektedir.'
  }, {
    id: 10,
    title: 'Hafıza Geliştirme Teknikleri',
    thumbnail: 'https://images.unsplash.com/photo-1503428593586-e225b39bddfe?w=300&h=180&fit=crop',
    duration: '15:20',
    category: 'Verimli Ders Çalışma',
    description: 'Hafızanızı güçlendirmek ve öğrendiğiniz bilgileri daha uzun süre hatırlamak için bilimsel olarak kanıtlanmış teknikler öğrenin. Bu videoda, bellek sarayı, aralıklı tekrar, zihin haritaları ve çağrışım teknikleri gibi etkili hafıza stratejileri anlatılmaktadır.'
  }, {
    id: 11,
    title: 'Etkili Dinleme Becerileri',
    thumbnail: 'https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=300&h=180&fit=crop',
    duration: '08:45',
    category: 'Verimli Ders Çalışma',
    description: 'Derslerde aktif dinleme, öğrenme sürecinin kritik bir parçasıdır. Bu video, daha iyi not alma, soru sorma teknikleri ve derslerde maksimum fayda sağlamak için dikkat odaklama stratejileri konularında değerli bilgiler içermektedir.'
  }, {
    id: 12,
    title: 'Özgüven Geliştirme Yöntemleri',
    thumbnail: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=300&h=180&fit=crop',
    duration: '12:30',
    category: 'Motivasyon',
    description: 'Akademik özgüven, başarının temel taşlarından biridir. Bu videoda, olumsuz düşünce kalıplarını değiştirme, kendi güçlü yönlerinizi tanıma ve başarısızlıklardan öğrenme yoluyla özgüveninizi nasıl geliştirebileceğiniz anlatılmaktadır.'
  }];
  const filteredVideos = guidanceVideos.filter(video => {
    const matchesSearch = video.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = activeCategory === null || activeCategory === 'Tümü' || video.category === activeCategory;
    return matchesSearch && matchesCategory;
  });
  // Play the featured video if provided
  const playFeaturedVideo = () => {
    if (featuredVideo) {
      // Find the matching video from our list to get the description
      const videoWithDetails = guidanceVideos.find(v => v.id === featuredVideo.id) || featuredVideo;
      setSelectedVideo(videoWithDetails);
    }
  };
  return <div className="space-y-6" data-id="element-429">
      <div className="flex items-center gap-4" data-id="element-430">
        <button onClick={onClose} className="flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:opacity-90 transition-all" data-id="element-431">
          <ArrowLeft className="w-5 h-5" data-id="element-432" />
          Geri
        </button>
        <h1 className="text-2xl font-bold" data-id="element-433">Tüm Rehberlik Videoları</h1>
      </div>

      {/* Featured Video Section (if provided) */}
      {featuredVideo && <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 mb-6" data-id="element-434">
          <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-435">
            <h2 className="text-xl font-bold mb-4" data-id="element-436">
              Haftanın Önerilen Videosu
            </h2>
            <div className="flex flex-col md:flex-row gap-4" data-id="element-437">
              <div className="w-full md:w-1/3 relative cursor-pointer group" onClick={playFeaturedVideo} data-id="element-438">
                <img src={featuredVideo.thumbnail} alt={featuredVideo.title} className="w-full aspect-video object-cover rounded-lg" data-id="element-439" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/50 rounded-lg" data-id="element-440">
                  <button className="w-16 h-16 flex items-center justify-center rounded-full bg-purple-600 hover:bg-purple-700 transition-colors" data-id="element-441">
                    <Play className="w-8 h-8 text-white fill-white ml-1" data-id="element-442" />
                  </button>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 bg-black/60 rounded-md flex items-center" data-id="element-443">
                  <Clock className="w-3 h-3 mr-1 text-purple-400" data-id="element-444" />
                  <span className="text-xs" data-id="element-445">{featuredVideo.duration}</span>
                </div>
              </div>
              <div className="w-full md:w-2/3" data-id="element-446">
                <h3 className="text-lg font-medium mb-2" data-id="element-447">
                  {featuredVideo.title}
                </h3>
                <p className="text-gray-400 mb-3" data-id="element-448">{featuredVideo.category}</p>
                <p className="text-sm text-gray-300" data-id="element-449">
                  {guidanceVideos.find(v => v.id === featuredVideo.id)?.description || 'Bu video, öğrencilerin akademik başarısını artırmak için tasarlanmış rehberlik içeriğidir. Videoyu izlemek için tıklayın.'}
                </p>
                <button onClick={playFeaturedVideo} className="mt-4 px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg text-white hover:opacity-90 transition-colors" data-id="element-450">
                  Videoyu İzle
                </button>
              </div>
            </div>
          </div>
        </div>}

      <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-451">
        <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-452">
          <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6" data-id="element-453">
            <div className="relative flex-1" data-id="element-454">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-455" />
              <input type="text" placeholder="Video ara..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full bg-white/5 text-white rounded-lg pl-10 pr-4 py-2 focus:ring-2 ring-purple-500/20" data-id="element-456" />
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-457">
              {categories.map(category => <button key={category} onClick={() => setActiveCategory(category === 'Tümü' ? null : category)} className={`px-3 py-1.5 rounded-full text-sm transition-colors ${category === 'Tümü' && activeCategory === null || category === activeCategory ? 'bg-purple-500 text-white' : 'bg-white/5 text-gray-300 hover:bg-white/10'}`} data-id="element-458">
                  {category}
                </button>)}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-459">
            {filteredVideos.map(video => <div key={video.id} className="flex-shrink-0 hover:scale-[1.03] transition-transform duration-200 cursor-pointer" onClick={() => setSelectedVideo(video)} data-id="element-460">
                <div className="relative rounded-lg overflow-hidden" data-id="element-461">
                  <img src={video.thumbnail} alt={video.title} className="w-full aspect-video object-cover" data-id="element-462" />
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity bg-black/50" data-id="element-463">
                    <Play className="w-12 h-12 text-white fill-white" data-id="element-464" />
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-1 bg-black/60 rounded-md flex items-center" data-id="element-465">
                    <Clock className="w-3 h-3 mr-1 text-purple-400" data-id="element-466" />
                    <span className="text-xs" data-id="element-467">{video.duration}</span>
                  </div>
                </div>
                <h3 className="mt-2 font-medium text-sm" data-id="element-468">{video.title}</h3>
                <p className="text-xs text-gray-400" data-id="element-469">{video.category}</p>
              </div>)}
          </div>
          {filteredVideos.length === 0 && <div className="text-center py-12 text-gray-400" data-id="element-470">
              Arama kriterlerinize uygun video bulunamadı.
            </div>}
        </div>
      </div>
      {selectedVideo && <VideoPlayerModal video={selectedVideo} onClose={() => setSelectedVideo(null)} data-id="element-471" />}
    </div>;
}